import { useRef } from "react";
import { useNavigate } from "react-router-dom";
import { Button } from "@/components/ui/button";
import { ArrowRight, FileSpreadsheet } from "lucide-react";
import { getIntroTheme } from "@/lib/seasonalIntro";
import IntroDemoSwitcher from "@/components/IntroDemoSwitcher";
import FullscreenIntroVideo, { SharpIntroVideo } from "@/components/FullscreenIntroVideo";

const introTheme = getIntroTheme();
const video = introTheme.video;
import { playCorporateChime } from "@/lib/corporateChime";
import { useAuth } from "@/contexts/AuthContext";

const Landing = () => {
  const navigate = useNavigate();
  const { user } = useAuth();
  const chimePlayed = useRef(false);

  const handleVideoPlay = () => {
    if (!chimePlayed.current) {
      chimePlayed.current = true;
      playCorporateChime();
    }
  };

  return (
    <div
      className={`min-h-screen flex flex-col px-6 py-8 text-foreground ${introTheme.dark ? "dark" : ""}`}
      style={{ background: introTheme.background }}
    >
      {introTheme.fullscreen && <FullscreenIntroVideo src={video} />}
      <IntroDemoSwitcher />
      <div className={`flex-1 flex flex-col items-center justify-center ${introTheme.fullscreen ? "relative z-10" : ""}`}>
        <div className="flex flex-col items-center max-w-3xl text-center space-y-6 md:space-y-8">
          {introTheme.fullscreen && (
            <SharpIntroVideo
              src={video}
              onPlay={handleVideoPlay}
              className="w-[20rem] sm:w-[28rem] md:w-[40rem] lg:w-[48rem]"
            />
          )}
          {!introTheme.fullscreen && (
          <div
            className="w-[20rem] sm:w-[28rem] md:w-[40rem] lg:w-[48rem] pointer-events-none select-none"
            translate="no"
            suppressHydrationWarning
            onContextMenu={(e) => e.preventDefault()}
            onDragStart={(e) => e.preventDefault()}
            style={{
              WebkitMaskImage:
                "radial-gradient(ellipse at center, black 80%, transparent 100%)",
              maskImage:
                "radial-gradient(ellipse at center, black 80%, transparent 100%)",
            }}
          >
            <video
              src={video}
              autoPlay
              muted
              playsInline
              draggable={false}
              className="w-full object-contain pointer-events-none select-none"
              onPlay={handleVideoPlay}
              onContextMenu={(e) => e.preventDefault()}
              controlsList="nodownload nofullscreen noremoteplayback"
              disablePictureInPicture
              disableRemotePlayback
            />
          </div>
          )}



          <div className="flex items-center gap-3">
            <FileSpreadsheet className="h-7 w-7 md:h-8 md:w-8 text-[hsl(152,40%,53%)]" />
            <p className="text-base md:text-xl font-medium text-muted-foreground tracking-wide">
              Procesador de facturas y Libro de IVA
            </p>
          </div>

          <Button
            size="lg"
            onClick={() => navigate(user ? "/app" : "/login")}
            className="bg-[hsl(152,40%,53%)] hover:bg-[hsl(152,40%,45%)] text-white font-semibold text-base px-10 gap-2 shadow-md"
          >
            Empezar
            <ArrowRight className="h-4 w-4" />
          </Button>
        </div>
      </div>

      <footer className="mt-8 text-center text-muted-foreground/50 text-xs flex items-center justify-center gap-3">
        <span>© {new Date().getFullYear()} Ferreiro & Portelo</span>
        <span>·</span>
        <button onClick={() => navigate("/privacidad")} className="hover:text-muted-foreground transition-colors">
          Política de privacidad
        </button>
      </footer>
    </div>
  );
};

export default Landing;
